import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {ExtendedFormBuilder} from '@aviary/forms/extensions/extended-form-builder/extended-form-builder';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {CommonValidators} from '@aviary/store/common/common.validators';
import {SelectFormFieldComponent} from '@aviary/forms/fields/select-form-field/select-form-field.component';
import {FormDialog, FormDialogDefinition} from '@aviary/dialogs/form-dialog/form-dialog.types';
import {FormDialogComponent} from '@aviary/dialogs/form-dialog/form-dialog.component';
import {CoverImageComponent} from '@aviary/components/cover-image/cover-image.component';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {BranchSelectors} from '@store/branches/branch.selectors';

export interface PlaceHoldBranchSelectionDialogData {
  catalogRecord: CatalogRecord;
  defaultBranchId: number;
}

export interface PlaceHoldBranchSelectionValue {
  pickupBranch: number;
}

@Component({
  selector: 'px-place-hold-branch-selection',
  template: `
    <mx-form-dialog [definition]="dialogDefinition">
      <div class="flex flex-row items-center w-full">
        <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="3.75" [heightRem]="5"/>
        <div class="px-1">
          <div class="text-title-large">{{ catalogRecordSelectors.titleFor(catalogRecord) | select }}</div>
          <div class="mat-caption">{{ catalogRecordSelectors.materialTypeDescriptionFor(catalogRecord) | select }}</div>
        </div>
      </div>
      <mx-select-form-field fieldName="pickupBranch" overrideLabel="Pickup Location" [formGroup]="pickupBranchForm"
                            [options]="pickupBranchSelector | select:[]" [includeUndefinedOption]="false"/>
    </mx-form-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectFormFieldComponent, FormDialogComponent, CoverImageComponent, SelectPipe]
})
export class PlaceHoldBranchSelectionDialog implements FormDialog<PlaceHoldBranchSelectionDialogData, PlaceHoldBranchSelectionValue> {
  public readonly dialogData: PlaceHoldBranchSelectionDialogData = inject(MAT_DIALOG_DATA);
  public readonly catalogRecord = this.dialogData.catalogRecord;
  public readonly catalogRecordSelectors = CatalogSelectors.Stateless;
  public readonly pickupBranchSelector = BranchSelectors.PickupLocations.pickupLocationsSelectOptions;
  private readonly fb: ExtendedFormBuilder = inject(ExtendedFormBuilder);
  public readonly pickupBranchForm: ExtendedFormGroup = this.fb.nonNullable.extendedGroup({
    pickupBranch: [this.dialogData.defaultBranchId, {validators: [Validators.required, CommonValidators.requiredIdSelect]}],
  });

  public readonly dialogDefinition: FormDialogDefinition<PlaceHoldBranchSelectionValue> = {
    title: 'Place Hold',
    confirmButtonLabel: 'Place Hold',
    formGroup: this.pickupBranchForm,
    allowConfirmWhenPristine: true
  };
}
